import {Organization} from "./organization.model.ts";
import {Employee} from "./employee.model.ts";
import {Permission} from "./permission.model.ts";

export class User {

    id: number;
    email: string;
    first_name: string;
    last_name: string;
    organization: Organization;
    employee: Employee;
    permissions: Permission;

    constructor() {

        this.id = -1;
        this.first_name = '';
        this.last_name = '';
        this.email = '';
        this.organization = new Organization();
        this.employee = new Employee();
        this.permissions = new Permission();
        /*
           How to check permissions.
           import {appStore} from "@store/appStore";

           const loggedInUser = appStore.loggedInUser;

           loggedInUser.permissions.hasAccess("Employees", PermissionLevels.VIEW | PermissionLevels.CREATE);
         */

    }

}

